import { CREATE_PARTNER, SET_LIST_PARTNERS, SET_PARTNER, UPDATE_PARTNER } from "../../reducerTypes"

const initialState = {
  list: [],
  getData: {},
}

const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_PARTNERS:
      return {
        ...state,
        list: action.payload
      }
    case SET_PARTNER:
      return {
        ...state,
        getData: action.payload
      }
    case CREATE_PARTNER:
      return {
        ...state,
        getData: action.payload
      }
    case UPDATE_PARTNER:
      return {
        ...state,
        getData: action.payload
      }
    default:
      return state
  }
}

export default partnerReducer
